import httpcommon3 from "./httpCommon3";
import ccOnboardingApi, { currentUserCode } from "./ccOnboardingApi";

export const ONBOARDING_CONFIG_BASE = "/onboarding-config";

function qs(params = {}) {
  const usp = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      usp.set(key, value);
    }
  });
  const s = usp.toString();
  return s ? `?${s}` : "";
}

export const FALLBACK_USERS = [
  {
    id: 1,
    code: "CB_USER_001",
    userCode: "priya.s",
    firstName: "Priya",
    lastName: "Sharma",
    fullName: "Priya S.",
    email: "priya.s@curebay.com",
    phoneNumber: "9876543210",
    roleCode: "DIAGGROUPADMIN",
    department: "Operations Team",
    status: 1,
    assignedScreens: ["Dashboard", "Lab Onboarding", "Collection Center Onboarding", "Hospital Onboarding", "Reports", "User Management", "Order Management", "Settings"],
    workflowConfig: {
      onboardingType: "LAB",
      role: "ONBOARD",
      state: "Odisha",
      stateCode: "OR",
      autoApprove: 1,
      status: 1,
    }
  },
  {
    id: 2,
    code: "CB_USER_002",
    userCode: "ravi.k",
    firstName: "Ravi",
    lastName: "Kumar",
    fullName: "Ravi Kumar",
    email: "ravi.kumar@curebay.com",
    phoneNumber: "9876543211",
    roleCode: "DIAGGROUPADMIN",
    department: "Business Team",
    status: 1,
    assignedScreens: ["Dashboard", "Lab Onboarding", "Reports", "Order Management", "Settings"],
    workflowConfig: {
      onboardingType: "CC",
      role: "BUSINESS",
      state: "Karnataka",
      stateCode: "KA",
      autoApprove: 0,
      status: 1,
    }
  },
  {
    id: 3,
    code: "CB_USER_003",
    userCode: "anjali.s",
    firstName: "Anjali",
    lastName: "Sharma",
    fullName: "Anjali Sharma",
    email: "anjali.sharma@curebay.com",
    phoneNumber: "9876543212",
    roleCode: "DIAGGROUPADMIN",
    department: "Finance Team",
    status: 1,
    assignedScreens: ["Dashboard", "Reports", "Order Management", "Finance Approval", "Audit Logs"],
    workflowConfig: {
      onboardingType: "LAB",
      role: "FINANCE",
      state: "Tamil Nadu",
      stateCode: "TN",
      autoApprove: 0,
      status: 1,
    }
  },
  {
    id: 4,
    code: "CB_USER_004",
    userCode: "manoj.k",
    firstName: "Manoj",
    lastName: "Kumar",
    fullName: "Manoj Kumar",
    email: "manoj.kumar@curebay.com",
    phoneNumber: "9876543213",
    roleCode: "DIAGGROUPADMIN",
    department: "Operations Team",
    status: 1,
    assignedScreens: ["Dashboard", "Lab Onboarding", "Reports", "Settings"],
    workflowConfig: {
      onboardingType: "CC",
      role: "ONBOARD",
      state: "Andhra Pradesh",
      stateCode: "AP",
      autoApprove: 1,
      status: 1,
    }
  },
  {
    id: 5,
    code: "CB_USER_005",
    userCode: "sneha.s",
    firstName: "Sneha",
    lastName: "Singh",
    fullName: "Sneha Singh",
    email: "sneha.singh@curebay.com",
    phoneNumber: "9876543214",
    roleCode: "DIAGGROUPADMIN",
    department: "Quality Assurance",
    status: 1,
    assignedScreens: ["Dashboard", "Lab Onboarding", "Collection Center Onboarding", "Reports", "Audit Logs", "Settings"],
    workflowConfig: {
      onboardingType: "LAB",
      role: "BUSINESS",
      state: "Maharashtra",
      stateCode: "MH",
      autoApprove: 1,
      status: 1,
    }
  },
  {
    id: 6,
    code: "CB_USER_006",
    userCode: "vikash.p",
    firstName: "Vikash",
    lastName: "Patel",
    fullName: "Vikash Patel",
    email: "vikash.patel@curebay.com",
    phoneNumber: "9876543215",
    roleCode: "DIAGGROUPADMIN",
    department: "Operations Team",
    status: 1,
    assignedScreens: ["Dashboard", "Lab Onboarding", "Reports"],
    workflowConfig: {
      onboardingType: "CC",
      role: "ONBOARD",
      state: "Gujarat",
      stateCode: "GJ",
      autoApprove: 0,
      status: 1,
    }
  },
  {
    id: 7,
    code: "CB_USER_007",
    userCode: "neha.j",
    firstName: "Neha",
    lastName: "Joshi",
    fullName: "Neha Joshi",
    email: "neha.joshi@curebay.com",
    phoneNumber: "9876543216",
    roleCode: "DIAGGROUPADMIN",
    department: "Compliance Team",
    status: 1,
    assignedScreens: ["Dashboard", "Lab Onboarding", "Reports", "Audit Logs", "Settings", "User Management", "Order Management"],
    workflowConfig: {
      onboardingType: "LAB",
      role: "FINANCE",
      state: "West Bengal",
      stateCode: "WB",
      autoApprove: 1,
      status: 1,
    }
  }
];

export const onboardingConfigApi = {
  getUsers: async ({ search = "", roleCode = "DIAGGROUPADMIN", page = 0, size = 50 } = {}) => {
    try {
      const response = await httpcommon3.get(
        `${ONBOARDING_CONFIG_BASE}/users${qs({ search, roleCode: roleCode || "DIAGGROUPADMIN", page, size })}`
      );
      if (response && response.status === 200 && response.data) {
        const resData = response.data.responseData || response.data.data || response.data;
        const rawList = resData?.content || resData?.users || (Array.isArray(resData) ? resData : []);
        if (Array.isArray(rawList)) {
          return rawList;
        }
      }
    } catch (err) {
      console.warn("API /onboarding-config/users error, falling back to mock dataset:", err);
    }
    return FALLBACK_USERS.filter((u) => (u.userRoleCode || u.roleCode || "").toUpperCase() === "DIAGGROUPADMIN" || !u.userRoleCode);
  },

  getUserWorkflowConfig: async (userCode) => {
    if (!userCode) return null;
    try {
      const response = await httpcommon3.get(`${ONBOARDING_CONFIG_BASE}/user/${userCode}`);
      if (response && response.status === 200 && response.data) {
        return response.data.responseData || response.data.data || response.data;
      }
    } catch (err) {
      const errMsg = err?.response?.data?.responseMessage || err?.response?.data?.message || err?.message;
      console.warn(`API /onboarding-config/user/${userCode} error:`, errMsg);
      try {
        const fallbackRes = await httpcommon3.get(`api/lab/login-workflow/config?userId=${userCode}`);
        if (fallbackRes && fallbackRes.status === 200 && fallbackRes.data) {
          const fbData = fallbackRes.data.responseData || fallbackRes.data.data || fallbackRes.data;
          if (fbData) return fbData;
        }
      } catch (err2) {
        // ignore
      }
      if (err?.response?.status === 404) {
        throw new Error(errMsg || `User ${userCode} not found (404)`);
      }
    }
    const matched = FALLBACK_USERS.find((u) => u.userCode === userCode || u.code === userCode);
    return matched?.workflowConfig ? { ...matched, configurations: [matched.workflowConfig] } : null;
  },

  saveWorkflowConfig: async (payload) => {
    const actorUser = currentUserCode() || "SYSTEM";
    const finalPayload = {
      userCode: payload.userCode || "",
      onboardingType: payload.onboardingType || "LAB",
      roleCode: payload.roleCode || payload.role || "SUBMITTER",
      stateCode: payload.stateCode || "",
      autoApprove: Number(payload.autoApprove !== undefined ? payload.autoApprove : 0),
      status: Number(payload.status !== undefined ? payload.status : 1),
      updatedBy: payload.updatedBy || actorUser,
    };
    if (payload.id) {
      finalPayload.id = payload.id;
    }
    try {
      const response = await httpcommon3.post(`${ONBOARDING_CONFIG_BASE}/user`, finalPayload);
      if (response && response.status === 200) {
        return response.data;
      }
    } catch (err) {
      const errMsg = err.response?.data?.responseMessage || err.response?.data?.message || err.message || "Could not save the configuration";
      console.error("API POST /onboarding-config/user error:", errMsg);
      throw new Error(errMsg);
    }
    return { responseCode: "200", responseMessage: "Data Saved Successfully", responseData: finalPayload };
  },

  deactivateConfig: async (id, updatedBy) => {
    const actorUser = updatedBy || currentUserCode() || "SYSTEM";
    try {
      const response = await httpcommon3.delete(`${ONBOARDING_CONFIG_BASE}/${id}${qs({ updatedBy: actorUser })}`);
      if (response && response.status === 200) {
        return response.data;
      }
    } catch (err) {
      const errMsg = err.response?.data?.responseMessage || err.response?.data?.message || err.message || "Failed to deactivate configuration";
      console.error(`API DELETE /onboarding-config/${id} error:`, errMsg);
      throw new Error(errMsg);
    }
    return { responseCode: "200", responseMessage: "Configuration deactivated" };
  },

  restoreConfig: async (id, updatedBy) => {
    const actorUser = updatedBy || currentUserCode() || "SYSTEM";
    try {
      const response = await httpcommon3.put(`${ONBOARDING_CONFIG_BASE}/${id}/restore${qs({ updatedBy: actorUser })}`);
      if (response && response.status === 200) {
        return response.data;
      }
    } catch (err) {
      const errMsg = err.response?.data?.responseMessage || err.response?.data?.message || err.message || "Failed to restore configuration";
      console.error(`API PUT /onboarding-config/${id}/restore error:`, errMsg);
      throw new Error(errMsg);
    }
    return { responseCode: "200", responseMessage: "Configuration restored" };
  },

  getAllScreens: async () => {
    try {
      const response = await httpcommon3.get(`api/lab/login-workflow/screens`);
      if (response && response.status === 200 && response.data) {
        const list = response.data.data || response.data.responseData || response.data;
        if (Array.isArray(list) && list.length > 0) {
          return list;
        }
      }
    } catch (err) {
      console.warn("API getAllScreens error, falling back to default master screens:", err);
    }
    return [
      { screen: 1, screenName: "Order Dashboard" },
      { screen: 2, screenName: "Order" },
      { screen: 3, screenName: "Mobilab Onboarding" },
      { screen: 4, screenName: "Lab Support" },
      { screen: 5, screenName: "Lab Onboarding" },
      { screen: 6, screenName: "CC Onboarding" },
      { screen: 7, screenName: "Business Approval" },
      { screen: 8, screenName: "Finance Approval" },
      { screen: 9, screenName: "Configuration" },
      { screen: 10, screenName: "Corporate" },
    ];
  },

  searchWorkflowConfigs: async ({ page = 0, size = 50, status = 1, onboardingType = "" } = {}) => {
    const params = { page, size, status };
    if (onboardingType) {
      params.onboardingType = onboardingType;
    }
    try {
      const response = await httpcommon3.get(`${ONBOARDING_CONFIG_BASE}/search${qs(params)}`);
      if (response && response.status === 200 && response.data) {
        return response.data.responseData || response.data.data || response.data;
      }
    } catch (err) {
      console.warn("API /onboarding-config/search error:", err);
      if (onboardingType) {
        try {
          const fallbackRes = await httpcommon3.get(`${ONBOARDING_CONFIG_BASE}/search${qs({ page, size, status })}`);
          if (fallbackRes && fallbackRes.status === 200 && fallbackRes.data) {
            return fallbackRes.data.responseData || fallbackRes.data.data || fallbackRes.data;
          }
        } catch (err2) {
          console.warn("Fallback /onboarding-config/search error:", err2);
        }
      }
    }
    return null;
  },

  getAllWorkflowConfigs: async () => {
    try {
      const response = await httpcommon3.get(`api/lab/login-workflow/config`);
      if (response && response.status === 200 && response.data) {
        const list = response.data.data || response.data.responseData || response.data.content || response.data;
        if (Array.isArray(list)) {
          return list;
        }
      }
    } catch (err) {
      console.warn("API getAllWorkflowConfigs error (api/lab/login-workflow/config):", err);
    }
    return [];
  },

  getUserScreens: async (userId) => {
    if (!userId) return [];
    try {
      const response = await httpcommon3.get(`api/lab/login-workflow/config?userId=${userId}`);
      if (response && response.status === 200 && response.data) {
        const list = response.data.data || response.data.responseData || response.data;
        if (Array.isArray(list)) {
          return list;
        }
      }
    } catch (err) {
      console.warn(`API getUserScreens error for userId=${userId}:`, err);
    }
    return [];
  },

  saveUserScreens: async ({ userId, screens, createdBy }) => {
    const actorUser = createdBy || currentUserCode() || "ADMIN";
    const screenIds = Array.isArray(screens)
      ? screens.map((s) => (typeof s === "object" ? Number(s.screen ?? s.id) : Number(s))).filter((s) => !isNaN(s))
      : [];

    const finalPayload = {
      userId: userId || "",
      screens: screenIds,
      createdBy: actorUser,
    };
    try {
      const response = await httpcommon3.post(`api/lab/login-workflow/config`, finalPayload);
      if (response && (response.status === 200 || response.status === 201)) {
        return response.data;
      }
    } catch (err) {
      const errMsg = err.response?.data?.message || err.response?.data?.responseMessage || err.message;
      console.error("API POST api/lab/login-workflow/config error:", errMsg);
      throw new Error(errMsg);
    }
    return finalPayload;
  },

  getUserConfigLogs: async ({ userId, page = 0, size = 10 } = {}) => {
    if (!userId) {
      return {
        content: [],
        page: { size, number: 0, totalElements: 0, totalPages: 0 },
      };
    }

    try {
      let response;
      try {
        response = await httpcommon3.get(
          `api/lab/login-workflowLog/configLog?userId=${userId}&page=${page}&size=${size}`
        );
      } catch (paramErr) {
        response = await httpcommon3.get(
          `api/lab/login-workflowLog/configLog?userId=${userId}`
        );
      }

      if (response && response.status === 200 && response.data) {
        const data = response.data;
        const resData = data.responseData || data.data || data;
        const rawContent = resData?.content !== undefined ? resData.content : (Array.isArray(resData) ? resData : []);
        const content = Array.isArray(rawContent) ? rawContent : [];

        return {
          content,
          page: resData.page || {
            size,
            number: page,
            totalElements: resData.totalElements ?? content.length,
            totalPages: resData.totalPages ?? (Math.ceil(content.length / size) || (content.length > 0 ? 1 : 0)),
          },
        };
      }
    } catch (err) {
      console.warn(`API getUserConfigLogs error for userId=${userId}:`, err);
    }

    return {
      content: [],
      page: {
        size,
        number: page,
        totalElements: 0,
        totalPages: 0,
      },
    };
  },

  getStateList: async () => {
    try {
      const res = await ccOnboardingApi.getStateList();
      const body = res?.data ?? res;
      let raw = [];
      if (Array.isArray(body)) {
        raw = body;
      } else if (Array.isArray(body?.successList)) {
        raw = body.successList;
      } else if (Array.isArray(body?.data)) {
        raw = body.data;
      } else if (Array.isArray(body?.list)) {
        raw = body.list;
      } else if (Array.isArray(body?.result)) {
        raw = body.result;
      }

      if (Array.isArray(raw) && raw.length > 0) {
        return raw.map((s, idx) => {
          if (typeof s === "string") {
            return { id: idx + 1, stateName: s, stateCode: s.length <= 3 ? s.toUpperCase() : "" };
          }
          const sName = s?.stateName || s?.state_name || s?.name || s?.label || "";
          let sCode = s?.stateCode || s?.state_code || s?.code || s?.value || "";
          if (!sCode && sName.toLowerCase() === "odisha") sCode = "OD";
          return {
            id: s?.id || idx + 1,
            stateName: sName,
            stateCode: sCode,
          };
        });
      }
    } catch (err) {
      console.warn("Failed to fetch state list:", err);
    }
    return [
      { id: 1, stateName: "Odisha", stateCode: "OD" },
      { id: 2, stateName: "Karnataka", stateCode: "KA" },
      { id: 3, stateName: "Tamil Nadu", stateCode: "TN" },
      { id: 4, stateName: "Andhra Pradesh", stateCode: "AP" },
      { id: 5, stateName: "Maharashtra", stateCode: "MH" },
      { id: 6, stateName: "Gujarat", stateCode: "GJ" },
      { id: 7, stateName: "West Bengal", stateCode: "WB" },
      { id: 8, stateName: "Telangana", stateCode: "TS" },
      { id: 9, stateName: "Kerala", stateCode: "KL" },
      { id: 10, stateName: "Madhya Pradesh", stateCode: "MP" },
      { id: 11, stateName: "Uttar Pradesh", stateCode: "UP" },
      { id: 12, stateName: "Rajasthan", stateCode: "RJ" },
      { id: 13, stateName: "Punjab", stateCode: "PB" },
      { id: 14, stateName: "Haryana", stateCode: "HR" },
      { id: 15, stateName: "Bihar", stateCode: "BR" },
      { id: 16, stateName: "Assam", stateCode: "AS" },
      { id: 17, stateName: "Delhi", stateCode: "DL" },
      { id: 18, stateName: "Jharkhand", stateCode: "JH" },
      { id: 19, stateName: "Chhattisgarh", stateCode: "CG" },
      { id: 20, stateName: "Uttarakhand", stateCode: "UK" },
      { id: 21, stateName: "Himachal Pradesh", stateCode: "HP" },
      { id: 22, stateName: "Goa", stateCode: "GA" },
    ];
  }
};

export default onboardingConfigApi;
